import { authorizeIfLoggedIn } from "../../../components/Auth/AuthorizedApiClientBase";
import { AccountManagementClient } from "./generated/AccountManagementClient"

export const AccountManagementClientFactory = () => {
    const accountManagementClient = new AccountManagementClient(process.env.ACCOUNT_MANAGEMENT_BACKEND_URL);
    authorizeIfLoggedIn(accountManagementClient);

    return accountManagementClient;
}